import { APP_INITIALIZER, ErrorHandler, NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { registerLocaleData } from '@angular/common';
import { LayoutComponent } from './core/component/layout/layout.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CookieService } from 'ngx-cookie-service';
import { ErrorInterceptor, LoadInterceptor } from './util/interceptors';
import { SharedComponentsModule } from './domain/shared/module/shared-components.module';
import en from '@angular/common/locales/en';
import { IConfig, provideEnvironmentNgxMask } from 'ngx-mask';
import { CoreModule } from './core/module/core.module';
import { MarkdownModule } from "ngx-markdown";
import * as Sentry from "@sentry/angular";
import { Router } from "@angular/router";

registerLocaleData(en);

const maskConfig: Partial<IConfig> = {
  validation: false,
};

@NgModule({
  declarations: [
    AppComponent,
  ],
  imports: [
    HttpClientModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    SharedComponentsModule,
    CoreModule,
    MarkdownModule.forRoot(),
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: LoadInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    CookieService,
    provideEnvironmentNgxMask(maskConfig),
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler({
        showDialog: false,
      }),
    }, {
      provide: Sentry.TraceService,
      deps: [Router],
    },
    {
      provide: APP_INITIALIZER,
      useFactory: () => (): void => {},
      deps: [Sentry.TraceService],
      multi: true,
    },
  ],
  exports: [],
  bootstrap: [LayoutComponent],
})
export class AppModule {
}
